module.exports = __webpack_public_path__ + "static/img/HD-img.0f3f6a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/detailpic/HD-img.jpg
// module id = VFcD
// module chunks = 52